(function(){'use strict';
var L=window.PZSE, $=L.$, $all=L.$all, CANVAS_PX=L.CANVAS_PX;
var BORDER_SETS={
sticker:[{v:0,label:'None'},{v:0.0625,label:'1/16″'},{v:0.125,label:'1/8″'},{v:0.1875,label:'3/16″'},{v:0.25,label:'1/4″'},{v:0.375,label:'3/8″'}],
cutout:[{v:0,label:'None'},{v:0.25,label:'1/4″'},{v:0.5,label:'1/2″'},{v:0.75,label:'3/4″'},{v:1,label:'1″'},{v:1.5,label:'1.5″'}]
};
var SHAPES=[{id:'contour',label:'Custom cut'},{id:'circle',label:'Circle'},{id:'square',label:'Square'},{id:'rounded',label:'Rounded'},{id:'rectangle',label:'Rectangle'},{id:'oval',label:'Oval'}];
L.SHAPES=SHAPES; L.BORDER_SETS=BORDER_SETS;
function Editor(root){
this.root=root;
this.cfg=JSON.parse(root.getAttribute('data-config')||'{}');
var c=this.cfg; c.mode=c.mode||'sticker';
this.borders=BORDER_SETS[c.mode==='cutout'?'cutout':'sticker'];
this.state={ shape:c.mode==='flat'?'rectangle':'contour', border:c.defaultBorder!=null?c.defaultBorder:(c.mode==='cutout'?0.5:0.125), cut:'Die cut', removeBg:true, artUrl:null, fit:'fill', orient:c.defaultOrient||'auto' };
this.art=L.sampleArt(); this.rawImg=null; this.cache={};
this.build(); this.bind(); this.render();
}
Editor.prototype.build=function(){
var r=this.root, self=this;
this.preview=$('.se-preview',r);
var media=$('.product__media-wrapper');
if(media&&this.preview){ this.preview.classList.add('se-preview--media'); media.insertBefore(this.preview,media.firstChild); }
this.canvas=$('canvas',this.preview); this.canvas.width=CANVAS_PX; this.canvas.height=CANVAS_PX;
this.ctx=this.canvas.getContext('2d');
this.dimEl=$('.se-dims',this.preview); this.noteEl=$('.se-note',this.preview);
var c=this.cfg;
var shapeWrap=$('.se-shapes',r);
if(shapeWrap){ if(c.shapes===false){ shapeWrap.closest('.se-group').hidden=true; } else SHAPES.forEach(function(s){ var b=document.createElement('button'); b.type='button'; b.className='se-chip'; b.setAttribute('data-shape',s.id); b.innerHTML='<span class="se-chip__icon se-icon--'+s.id+'"></span><span>'+s.label+'</span>'; shapeWrap.appendChild(b); }); }
var bw=$('.se-borders',r);
if(bw){ if(c.mode==='flat'){ bw.closest('.se-group').hidden=true; } else this.borders.forEach(function(bd,i){ var b=document.createElement('button'); b.type='button'; b.className='se-chip se-chip--small'; b.setAttribute('data-border',i); b.textContent=bd.label; bw.appendChild(b); }); }
var cutG=$('.se-cut',r); if(cutG&&(c.cutChips===false)) cutG.hidden=true;
var fitG=$('.se-fit',r); if(fitG) fitG.hidden=c.mode!=='flat';
var orG=$('.se-orient',r); if(orG) orG.hidden=!c.orient;
this.bgRow=$('.se-bg',r); this.bgInput=$('.se-bg input',r);
this.formId=r.getAttribute('data-form-id');
this.syncUi();
};
Editor.prototype.bind=function(){
var self=this, r=this.root;
r.addEventListener('click',function(e){
var t=e.target.closest('[data-shape],[data-border],[data-cut],[data-fit],[data-orient]'); if(!t) return;
if(t.hasAttribute('data-shape')) self.state.shape=t.getAttribute('data-shape');
if(t.hasAttribute('data-border')) self.state.border=self.borders[+t.getAttribute('data-border')].v;
if(t.hasAttribute('data-cut')) self.state.cut=t.getAttribute('data-cut');
if(t.hasAttribute('data-fit')) self.state.fit=t.getAttribute('data-fit');
if(t.hasAttribute('data-orient')) self.state.orient=t.getAttribute('data-orient');
self.update();
});
if(this.bgInput) this.bgInput.addEventListener('change',function(){ self.state.removeBg=self.bgInput.checked; self.reanalyze(); self.update(); });
document.addEventListener('change',function(e){ if(e.target&&/options\[|variant/i.test(e.target.name||e.target.id||'')) setTimeout(function(){ self.render(); },50); },true);
if(window.subscribe&&window.PUB_SUB_EVENTS){ try{ window.subscribe(window.PUB_SUB_EVENTS.variantChange,function(){ setTimeout(function(){ self.render(); },50); }); }catch(e){} }
setInterval(function(){ self.pollUpload(); },700);
window.addEventListener('resize',function(){ self.render(); });
};
Editor.prototype.form=function(){ return (this.formId&&document.getElementById(this.formId))||$('form[action*="/cart/add"]'); };
Editor.prototype.pollUpload=function(){
var url=null, thumbs=$all('.uploadkit img, .uploadkit-thumbnails img');
for(var t=0;t<thumbs.length;t++){ var mm=(thumbs[t].currentSrc||thumbs[t].src||'').match(/^https?:\/\/[^\/]*ucarecd[^\/]*\/([0-9a-f-]{36})/i); if(mm){ url='https://ucarecdn.com/'+mm[1]+'/'; break; } }
if(!url){ var f=this.form(), nodes=f?$all('input',f):[]; for(var i=0;i<nodes.length;i++){ var m2=(nodes[i].value||'').match(/^https?:\/\/[^\/ ]*ucarecd[^\/ ]*\/([0-9a-f-]{36})/i); if(m2){ url='https://ucarecdn.com/'+m2[1]+'/'; break; } } }
if(!url&&this.state.source==='local') return;
if(url!==this.state.artUrl){ this.state.artUrl=url; this.state.source=url?'upload':null; if(url) this.loadArt(url); else { this.rawImg=null; this.art=L.sampleArt(); this.setNote(''); this.update(); } }
};
Editor.prototype.loadArt=function(url){
var self=this, base=url.replace(/\/+$/,'/');
var cands=/ucarecd/.test(base)?[base+'-/preview/2000x2000/-/format/png/',base+'-/format/png/',url]:[url];
this.setNote('Loading your artwork…');
(function next(i){
if(i>=cands.length){ self.setNote('We couldn’t preview this file, but it’s attached to your order and we’ll still print it.'); return; }
var img=new Image(); img.crossOrigin='anonymous';
img.onload=function(){ if(url!==self.state.artUrl) return; self.rawImg=img; self.reanalyze(); self.setNote(''); self.update(); };
img.onerror=function(){ next(i+1); }; img.src=cands[i];
})(0);
};
Editor.prototype.setArtwork=function(img){ this.rawImg=img; this.state.source='local'; this.state.artUrl='local'; this.reanalyze(); this.update(); };
Editor.prototype.reanalyze=function(){ if(!this.rawImg) return; this.art=L.analyzeArt(this.rawImg,this.cfg.mode==='flat'?false:this.state.removeBg); if(this.art.tainted) this.setNote('Preview limited for this file; it’s still attached to your order.'); this.cache={}; };
Editor.prototype.setNote=function(t){ if(this.noteEl){ this.noteEl.textContent=t; this.noteEl.hidden=!t; } };
Editor.prototype.dims=function(){
var o=L.selectedOptions(), c=this.cfg, w=null, h=null, k;
var hk=Object.keys(o).filter(function(n){ return /height/i.test(n); })[0], lk=Object.keys(o).filter(function(n){ return /length|width/i.test(n); })[0];
if(hk&&lk){ h=L.parseLen(o[hk]); w=L.parseLen(o[lk]); }
if(w==null){ k=Object.keys(o).filter(function(n){ return /size/i.test(n)&&!/shirt/i.test(n); })[0];
if(k){ var p=L.parsePair(o[k]); if(p){ w=p.w; h=p.h; } else { var s=L.parseLen(o[k]); if(s){ w=s; h=s; } } } }
if(w==null){ w=c.defaultW||3; h=c.defaultH||w; }
return { w:w, h:h, opts:o };
};
Editor.prototype.update=function(){ this.syncUi(); this.render(); };
Editor.prototype.syncUi=function(){
var st=this.state, r=this.root, self=this;
$all('[data-shape]',r).forEach(function(b){ b.classList.toggle('is-active',b.getAttribute('data-shape')===st.shape); });
$all('[data-border]',r).forEach(function(b){ b.classList.toggle('is-active',self.borders[+b.getAttribute('data-border')].v===st.border); });
$all('[data-cut]',r).forEach(function(b){ b.classList.toggle('is-active',b.getAttribute('data-cut')===st.cut); });
$all('[data-fit]',r).forEach(function(b){ b.classList.toggle('is-active',b.getAttribute('data-fit')===st.fit); });
$all('[data-orient]',r).forEach(function(b){ b.classList.toggle('is-active',b.getAttribute('data-orient')===st.orient); });
var lab=$('.se-border-label',r); if(lab) lab.textContent=st.shape==='contour'?'White border around your design':'Margin inside the shape';
if(this.bgRow) this.bgRow.hidden=!(this.rawImg&&this.art&&this.art.bgRemovable&&this.cfg.mode!=='flat');
if(this.bgInput) this.bgInput.checked=!!st.removeBg;
};
Editor.prototype.writeProps=function(){
var form=this.form(); if(!form) return;
var st=this.state, c=this.cfg, props={};
if(c.mode!=='flat'){
if(c.cutChips!==false) props['Cut']=st.cut;
props['Shape']=SHAPES.filter(function(s){ return s.id===st.shape; })[0].label;
var bl=this.borders.filter(function(x){ return x.v===st.border; })[0];
props[st.shape==='contour'?'Border':'Margin']=bl?bl.label+(bl.v?' ('+bl.v+' in)':''):'';
if(this.art&&this.art.bgRemovable&&this.rawImg) props['Remove background']=st.removeBg?'Yes':'No';
} else {
props['Artwork fit']=st.fit==='fill'?'Fill (edge to edge)':'Fit (whole design visible)';
if(c.orient) props['Orientation']=this.orientLabel||'';
}
props['Finished size']=this.dimsText||'';
var sig=JSON.stringify(props); if(sig===this._propSig&&form.querySelector('.se-props')) return; this._propSig=sig;
var holder=form.querySelector('.se-props'); if(!holder){ holder=document.createElement('div'); holder.className='se-props'; holder.hidden=true; form.appendChild(holder); }
holder.innerHTML='';
Object.keys(props).forEach(function(k){ if(props[k]==='') return; var i=document.createElement('input'); i.type='hidden'; i.name='properties['+k+']'; i.value=props[k]; holder.appendChild(i); });
};
L.Editor=Editor;
})();